module.exports = __webpack_public_path__ + "media/images/lb/831-2171bfae88ac8e3fc904f691053907e4.svg";